<template>
  <legal-page title="Políticas de Seguridad">
    <div class="legal-sections">
      <legal-section
        title="Website"
        icon="GlobeIcon"
        variant="info"
      >
        <p>
          Tomamos todas las medidas y precauciones razonables para
          proteger tu información personal y seguimos las mejores
          prácticas de la industria para asegurar que tu información
          no sea utilizada de manera inapropiada, alterada o
          destruida.
        </p>
        <p>
          Ciframos la información de tu tarjeta de crédito utilizando
          la tecnología de capa de puertos seguros o Secure Sockets
          Layer (SSL), y la almacenamos con el cifrado AES-256.
          También, seguimos todos los requerimientos del PCI-DSS.
        </p>
      </legal-section>

      <legal-section
        title="Pagos"
        icon="CreditCardIcon"
        variant="success"
      >
        <p>
          Los métodos de pago utilizados por {{ business.name }} son
          servicios de terceros. Estos servicios de terceros (AZUL)
          cumplen con todos los estándares de seguridad y cifrado para
          mantener tu información segura. Solo utilizarán la
          información necesaria para completar el proceso requerido.
          También recomendamos leer las Políticas de Privacidad de
          estos proveedores, para entender mejor cómo manejan la
          información suministrada.
        </p>
      </legal-section>

      <legal-section
        title="Autenticación 3D Secure"
        icon="ShieldIcon"
      >
        <p>
          Las transacciones con tarjeta están protegidas por los
          protocolos de autenticación
          <strong>Visa Secure</strong> y
          <strong>Mastercard ID Check</strong>, que añaden una capa
          adicional de verificación del tarjetahabiente al momento del
          pago.
        </p>

        <!-- Los sellos vivían flotando arriba de la página, sueltos sobre el
             fondo. Acá quedan junto al texto que los explica y dentro de una
             tira con borde, que es lo que los hace leer como sello y no como
             imagen pegada. -->
        <div class="security-badges">
          <b-img
            :src="visaSecure"
            alt="Visa Secure"
            height="40"
          />
          <b-img
            :src="mcIdCheck"
            alt="Mastercard ID Check"
            height="40"
          />
        </div>
      </legal-section>
    </div>
  </legal-page>
</template>

<script>
/* eslint-disable global-require */
import { BImg } from "bootstrap-vue"
import business from "@/business"
import LegalPage from "./LegalPage.vue"
import LegalSection from "./LegalSection.vue"

export default {
  components: { LegalPage, LegalSection, BImg },
  data() {
    return {
      business,
      visaSecure: require("@/assets/images/brands/visa-secure.png"),
      mcIdCheck: require("@/assets/images/brands/mastercard-idcheck.png"),
    }
  },
}
</script>

<style lang="scss" scoped>
.security-badges {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
    margin-top: 1.125rem;
    padding: 0.875rem 1rem;
    border: 1px solid var(--tm-border);
    border-radius: var(--tm-radius-sm);
    background-color: var(--tm-surface-muted);
}
</style>
